export type { ResultGlassProps } from "./ResultGlass";
export { default, ResultType, SharingType } from "./ResultGlass";
